import { QuestCategoryOption } from '.';

export const categoryAll: QuestCategoryOption = {
	label: 'all',
	value: null
};
